import { Component, inject, output, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
	OAuthAuthorizationConfig,
	PkceService,
} from '@services/email/pkce.service';
import { Logger } from '@core/logger';
import { CommonModule } from '@angular/common';

export type EmailProvider = 'gmail' | 'outlook' | null;

@Component({
	selector: 'app-selection-auth-modal',
	templateUrl: './selection-auth-modal.component.html',
	imports: [CommonModule],
})
export class SelectionAuthModalComponent {
	pkceService = inject(PkceService);
	selectedProvider = signal<EmailProvider>(null);
	providerSelected = output<EmailProvider>();

	onProviderSelect(provider: EmailProvider) {
		this.selectedProvider.set(provider);
		this.providerSelected.emit(provider);
	}

	startOAuthFlow(provider: EmailProvider) {
		if (provider === 'outlook') {
			this.startOutlookOAuth();
		} else if (provider === 'gmail') {
			// TODO: Implement Gmail OAuth when ready
			console.log('Gmail OAuth not implemented yet');
		}
	}

	private startOutlookOAuth() {
		Logger.info('Outlook OAuth login initiated');

		const config: OAuthAuthorizationConfig = {
			clientId: environment.outlookOAuth.clientId,
			scope: environment.outlookOAuth.scopes,
			redirectUri: environment.outlookOAuth.authRequestRedirectUri,
			urlBeforeQuery: `${environment.outlookOAuth.baseLoginUrl}/oauth2/v2.0/authorize`,
		};

		window.location.href =
			this.pkceService.BuildOAuthUrl(config) +
			`&prompt=login&audience=${config.clientId}`;
	}
}
